import { LeadTimeStrategy } from '@snap-types/models/enums';

const leadTimeConfigTypesForSite: Record<string, LeadTimeStrategy[]> = {
  // QUANTITY_AWARE only produces run hours for `PCS/HR` routings; every other
  // Visual run rate contributes setup and transit alone. That holds for cap.
  // Before offering it to another site, check that site's routings and see
  // `calculateOperationHours` in the calculations package.
  cap: [
    LeadTimeStrategy.CONSTANT_VALUE,
    LeadTimeStrategy.PLANNING_LEADTIME,
    LeadTimeStrategy.QUANTITY_AWARE,
  ],
  raf: [
    LeadTimeStrategy.CONSTANT_VALUE,
    LeadTimeStrategy.PLANNING_LEADTIME,
    LeadTimeStrategy.RAF_FIXED_MARKET,
  ],
  default: [
    LeadTimeStrategy.CONSTANT_VALUE,
    LeadTimeStrategy.PLANNING_LEADTIME,
  ],
};

export const leadTimeConfigOptions = {
  [LeadTimeStrategy.CONSTANT_VALUE]: 'Constant Value',
  [LeadTimeStrategy.PLANNING_LEADTIME]: 'Planning Lead Time',
  [LeadTimeStrategy.RAF_FIXED_MARKET]: 'Fixed Market',
  [LeadTimeStrategy.QUANTITY_AWARE]: 'Quantity Aware',
} as const satisfies Record<LeadTimeStrategy, string>;

export function getAvailableLeadTimeConfigTypes(
  siteCode: string,
  existingTypes: LeadTimeStrategy[] = [],
): { all: LeadTimeStrategy[]; available: LeadTimeStrategy[] } {
  const siteAvailableTypes =
    leadTimeConfigTypesForSite[siteCode.toLowerCase()] ??
    leadTimeConfigTypesForSite.default;

  return {
    all: siteAvailableTypes,
    available: siteAvailableTypes.filter(
      (type) => !existingTypes.includes(type),
    ),
  };
}
